import { fetchData } from './../_helpers/fetchData';
import * as schema from './../_schema/user.json';
var profile = function () {
    return fetchData(schema.profile.get).then(function (response) { return ({ response: response }); }, function (error) { return ({ error: error }); });
};
export var userService = {
    profile: profile,
};
